import { useEffect } from 'react';
import { makePostCall } from '../../../utils/helper';
import { REPORT_CONFIG } from '../constants';

/**
 * Manages the "session" for an active report editing session:
 *  - Pings the server every KEEP_ALIVE_INTERVAL_MS to signal the user is still active
 *  - Sends a close-report call on beforeunload (browser close/navigate away)
 *  - Cleans up interval and event listener on unmount
 */
export const useReportSession = (orderId: number | undefined) => {
  useEffect(() => {
    if (!orderId) return;

    const handleBeforeUnload = async () => {
      try {
        await makePostCall('/close-report', { order_id: orderId, status: '' });
      } catch (error) {
        console.error('Failed to reset status on exit:', error);
      }
    };

    const pingInterval = setInterval(async () => {
      try {
        await makePostCall('/study-ping', { order_id: orderId, status: 'R' });
      } catch (error) {
        console.error('Keep-alive ping failed:', error);
      }
    }, REPORT_CONFIG.KEEP_ALIVE_INTERVAL_MS);

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      clearInterval(pingInterval);
    };
  }, [orderId]);
};
